<template>
    <secition-card
        title="방문자"
        v-bind="{
            titleActionProps: { to: '/console/statistics/visitors' },
            loading,
        }"
    >
        <statistics-chart-visits v-bind="{ statistics, searchDateValue }" />
    </secition-card>
</template>

<script>
import api from "@/api";
import SecitionCard from "@/components/console/dumb/secition-card.vue";
import StatisticsChartVisits from "@/components/console/statistics/chart/statistics-chart-visits.vue";

export default {
    components: {
        SecitionCard,
        StatisticsChartVisits,
    },
    props: {
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        statistics: [],

        loading: false,
    }),
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { searchDateValue } = this;
                const { statistics } = await api.console.statistics.visits.gets({
                    params: { searchDateValue },
                    headers: { limit: 10, mode: "daily-statistics" },
                });
                this.statistics = statistics;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>
